import template from './startingLetter.template.html';

export default {
  template,
  bindings: {
    data: '<',
    list: '=',
    onChange: '&'
  },
controller: class controller {
    constructor($mdMedia) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdMedia = $mdMedia;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = function () {
        ctrl.list.initGroupingByFirstLetter(ctrl.data);
      };
      ctrl.change = function (letter) {
        ctrl.list.setGroupingByFirstLetter(letter);
        ctrl.onChange();
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      ctrl.$onChanges = function (changes) {
        if (changes.data && changes.data.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
